module.exports = __webpack_public_path__ + "static/media/postsales.35e7e0b9.webp";